import { render, staticRenderFns } from "./MChat.vue?vue&type=template&id=eda2538a&"
import script from "./MChat.vue?vue&type=script&lang=ts&"
export * from "./MChat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports